import React from 'react';
import config from '../config/config';
import { useAsyncInterval } from '../hooks/useAsyncInterval';
import { useAppDispatch } from '../store';
import { updateAssetPrice } from '../store/prices/pricesSlice';

const BackgroundServices = () => {
  const dispatch = useAppDispatch();

  // Refresh asset prices
  useAsyncInterval(async () => {
    const enabledAssets = config.assets;
    await Promise.all(
      Object.keys(enabledAssets).map(async (key) => {
        return await dispatch(updateAssetPrice(enabledAssets[key].asset));
      })
    );
  }, 60 * 1000);

  return <></>;
};

export default BackgroundServices;
